<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import Result from '@/router/views/license/importResult'
import { Helper } from '@/mixin/helper'
import { GET_ADDRESS_UPLOAD_HISTORY } from '@/services/api/master/address'
import { IMPORT_USER_DOCS } from '@/services/api/license/userDocs'
import { mapGetters } from 'vuex'

export default {
  page: {
    title: 'Pengemudi',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Result,
  },
  mixins: [Helper],
  apollo: {
    importHistory: {
      query: GET_ADDRESS_UPLOAD_HISTORY,
      variables() {
        return {
          filter: {
            model: 'UserDoc',
            orderBy: [JSON.stringify({ importOn: 'desc' })],
          },
        }
      },
      manual: true,
      fetchPolicy: 'no-cache',
      result({ data, loading }) {
        if (loading) return
        this.totalRows = data.importHistory.importHistory.length
        this.filteredItems = data.importHistory.importHistory
        this.importHistory = data.importHistory.importHistory
      },
      error(error) {
        console.log('errors', error.graphQLErrors)
      },
    },
  },
  data() {
    return {
      importHistory: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      filteredItems: [],
      file: null,
      fileProp: {
        name: null,
        size: 0,
        sizeProgress: 0,
        message: null,
        error: false,
        progressVal: 0,
      },
      showRemovedBtn: false,
      importResponse: false,
      responseData: {
        totalFailed: null,
        totalSuccess: null,
        totalData: null,
        errorFile: null,
        fileName: null,
        fileType: null,
      },
    }
  },
  computed: {
    /**
     * Total no. of records
     */

    rows() {
      return this.importHistory.length
    },

    title() {
      return this.$t('license.title.uploadDriver')
    },
    historyUpload() {
      return [
        {
          key: 'importOn',
          label: this.$t('global.time.time'),
          sortable: true,
        },
        {
          key: 'filename',
          label: this.$t('license.object.fileName'),
          sortable: true,
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true,
        },
        {
          key: 'users.fullname',
          label: this.$t('license.object.uploadedBy'),
          sortable: true,
        },
      ]
    },
    ...mapGetters({
      isWhitelabel: 'identity/isWhitelabel',
      isMetrack: 'identity/isMetrack',
    }),

    illustrationPathFile() {
      if (this.isWhitelabel() || this.isMetrack()) {
        return require(`@/assets/images/illustration/whitelabel/file.svg`)
      }
      return require(`@/assets/images/illustration/saas/file.svg`)
    },

    illustrationPathUploading() {
      if (this.isWhitelabel() || this.isMetrack()) {
        return require(`@/assets/images/illustration/whitelabel/uploading.svg`)
      }
      return require(`@/assets/images/illustration/saas/uploading.svg`)
    },
  },
  mounted() {
    this.$apollo.queries.importHistory.refetch()
  },
  methods: {
    focusSearch() {
      this.$refs.searchInput.focus()
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    directTo() {
      this.$bvModal.hide('modal-template-download')
    },
    refreshData() {
      this.$apollo.queries.importHistory.refetch()
    },
    async fileChangeHandler(e) {
      const files = e.target.files
      this.file = files[0]
      this.fileProp.name = files[0].name
      this.fileProp.size = (files[0].size / (1024 * 1024)).toFixed(2)

      const input = {
        filebase64: null,
        filename: files[0].name,
      }

      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => resolve(reader.result)
          reader.onerror = (error) => reject(error)
        })

      input.filebase64 = (await toBase64(files[0])).split(',')[1]

      if (
        files[0].type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        files[0].type === 'text/csv'
      ) {
        if (this.fileProp.size > 10) {
          this.fileProp.message = this.$t('license.text.tooLarge')
          this.fileProp.error = true
          return
        }
        this.fileProp.error = false
        this.showRemovedBtn = true

        const param = [15, 25, 50, 70, 90, 100]
        for (let i = 0; i < param.length; i++) {
          setTimeout(() => {
            this.fileProp.sizeProgress = ((this.fileProp.size * param[i]) / 100).toFixed(2)
            this.fileProp.progressVal = param[i]
            if (param[i] === 100) {
              setTimeout(() => {
                this.$apollo
                  .mutate({
                    mutation: IMPORT_USER_DOCS,
                    variables: {
                      input: input,
                    },
                  })
                  .then((response) => {
                    if (response.data.importUserDoc.isSuccessful) {
                      this.importResponse = true
                      this.responseData.totalData =
                        response.data.importUserDoc.importUserDoc.totalData
                      this.responseData.totalFailed =
                        response.data.importUserDoc.importUserDoc.totalFailed
                      this.responseData.totalSuccess =
                        response.data.importUserDoc.importUserDoc.totalSuccess
                      this.responseData.errorFile =
                        response.data.importUserDoc.importUserDoc.errorFile
                      this.responseData.fileName = files[0].name
                      this.responseData.fileType = files[0].type
                    } else {
                      if (response.data.importUserDoc.message == 'Error: "Incorrect File Used."') {
                        this.fileProp.message = this.$t('license.text.template')
                        this.fileProp.error = true
                      } else {
                        return this.$mcToast.warning(response.data.importUserDoc.message)
                      }
                    }
                  })
              }, 1000)
            }
          }, i * 500)
        }
      } else {
        this.fileProp.message = this.$t('license.text.incompatible')
        this.fileProp.error = true
      }
    },
    deleteFile() {
      this.importResponse = false
      this.file = null
      this.fileProp = {
        name: null,
        size: 0,
        sizeProgress: 0,
        message: null,
        error: false,
        progressVal: 0,
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" class="mc-page-three" />

      <p class="mb-4">{{ $t('license.text.uploadDriver') }}</p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button
            v-b-modal.modal-history-upload
            variant="outline-primary"
            class="ms-3"
            @click="refreshData"
          >
            <i class="mc-fa icon-outline_file-text"></i> {{ $t('license.object.uploadHistory') }}
          </b-button>
          <b-button @click="deleteFile" variant="primary" class="ms-2" v-if="importResponse">
            <i class="mc-fa icon-outline_upload"></i> {{ $t('license.object.reupload') }}
          </b-button>
          <b-button
            @click="$router.push({ name: 'List License' })"
            variant="outline-primary"
            class="ms-3"
          >
            <i class="mc-fa icon-outline_arrow-left"></i>
            {{ $t('global.back') }}
          </b-button>
        </div>
      </div>
    </div>

    <div class="card" v-if="!importResponse">
      <div class="card-body">
        <div class="mc-upload d-flex justify-content-between">
          <div class="mc-upload__file">
            <div class="mc-upload__file-wrapper">
              <div class="mc-upload__file-area" v-if="fileProp.name == null">
                <input
                  id="inputfile"
                  ref="inputfile"
                  type="file"
                  @change="fileChangeHandler"
                  @drop="fileChangeHandler"
                  name="attachment"
                  class="mc-upload__file-area-input"
                  accept=".xlsx, .csv"
                />

                <div class="mc-upload__file-area-text">
                  <img :src="illustrationPathFile" alt />
                  <p>{{ $t('license.text.selectOrDrop') }}</p>
                  <p>({{ $t('license.text.maximum') }})</p>
                </div>
              </div>
              <div
                :class="`mc-upload__file-result ${
                  fileProp.error ? 'mc-upload__file-result--error' : null
                }`"
                v-else
              >
                <div class="mc-upload__file-result-wrapper">
                  <img :src="illustrationPathUploading" alt />
                  <h4 class="mc-upload__file-result-status">
                    {{ fileProp.message }}
                  </h4>
                  <div class="mc-upload__file-result-desc d-flex justify-content-between">
                    <span>{{ fileProp.name }}</span>
                    <span v-if="fileProp.error">
                      <i class="mc-fa icon-outline_trash-2" @click="deleteFile"></i>
                      <i class="mc-fa icon-fill_alert-triangle"></i>
                    </span>
                  </div>
                  <div class="mc-upload__file-result-progress">
                    <div :style="`width: ${fileProp.progressVal}%`"></div>
                  </div>
                  <span class="mc-upload__file-result-filesize">
                    <span>{{ fileProp.sizeProgress }} MB / </span>{{ fileProp.size }} MB
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="mc-upload__info">
            <div class="mc-upload__info-wrapper">
              <h3 class="mc-upload__info-title">
                <i class="mc-fa icon-outline_book"></i> {{ $t('license.object.guide') }}
              </h3>
              <ul class="mc-upload__info-list">
                <li>
                  <strong>{{ $t('license.object.downloadTemplate') }}</strong>
                  <p>
                    {{ $t('license.text.downloadTemplate') }}
                  </p>
                  <b-button variant="primary" size="sm" v-b-modal.modal-template-download
                    ><i class="mc-fa icon-outline_download"></i>
                    {{ $t('license.object.downloadTemplate') }}</b-button
                  >
                </li>
                <li>
                  <strong>{{ $t('license.object.copyData') }}</strong>
                  <p>
                    {{ $t('license.text.copyData') }}
                  </p>
                </li>
                <li>
                  <strong>{{ $t('license.object.uploadFile') }}</strong>
                  <p>
                    {{ $t('license.text.uploadFile1') }}
                    <b>.csv</b> {{ $t('global.object.or') }} <b>.xlsx</b>.
                    {{ $t('license.text.uploadFile2') }}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Result
      v-else
      :totalFailed="responseData.totalFailed"
      :totalSuccess="responseData.totalSuccess"
      :totalData="responseData.totalData"
      :errorFile="responseData.errorFile"
      :fileName="responseData.fileName"
      :fileType="responseData.fileType"
      :docType="'Pengemudi'"
    />

    <b-modal
      class="mc-modal"
      id="modal-history-upload"
      :title="$t('license.object.uploadHistory')"
      size="lg"
      centered
      scrollable
    >
      <div class="clearfix">
        <!-- Search -->
        <div class="float-end">
          <div class="mc-table-view">
            <div id="tickets-table_filter" class="dataTables_filter text-md-end">
              <label
                class="d-inline-flex align-items-center mc-table-view__search"
                @click="focusSearch"
              >
                <i class="mc-fa fas fa-search"></i>
                <b-form-input
                  v-model="filter"
                  type="search"
                  :placeholder="$t('global.search') + '...'"
                  class="ms-2"
                  ref="searchInput"
                ></b-form-input>
              </label>
            </div>
          </div>
        </div>
        <!-- End search -->
      </div>

      <!-- Table -->
      <div class="table-responsive my-3 border border-1">
        <b-table
          small
          show-empty
          :fields="historyUpload"
          :items="importHistory"
          class="datatables"
          responsive="sm"
          sort-by="groupNameService"
          empty-table
          :empty-text="$t('global.emptyTable')"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
        >
          <template #cell(importOn)="row">
            <p class="my-0">{{ momentDateShortMonth(row.value) }}</p>
            <p class="text-muted my-0">{{ momentTime(row.value) }}</p>
          </template>

          <template #cell(status)="data">
            <span class="mc-status mc-status--green" v-if="data.item.totalFailed === 0">
              {{ $t('license.object.success') }}
            </span>
            <span class="mc-status mc-status--red" v-else-if="data.item.totalSuccess === 0">
              {{ $t('license.object.failed') }}
            </span>
            <span
              class="mc-status mc-status--yellow"
              v-else-if="data.item.totalSuccess > 0 && data.item.totalFailed > 0"
            >
              {{ $t('license.object.partialSuccess') }}
            </span>
          </template>
        </b-table>
      </div>

      <div class="row">
        <div class="col-sm-12 col-md-6">
          <div id="tickets-table_length" class="dataTables_length">
            <label class="d-inline-flex align-items-center">
              {{ $t('global.text.displays') }}
              <b-form-select
                class="form-select form-select-sm"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
              ></b-form-select>
              {{ $t('global.text.entries') }}
            </label>
          </div>
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="text-end">
            <b-button variant="outline-primary" @click="cancel()">
              {{ $t('global.action.close') }}
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
    <b-modal
      class="mc-modal"
      id="modal-template-download"
      :title="$t('license.object.downloadTemplate')"
      size="md"
      centered
      scrollable
    >
      <p class="mc-modal-text">
        {{ $t('license.text.templateDataDownload') }}
      </p>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="text-end">
            <b-button variant="outline-primary" @click="cancel()">
              {{ $t('global.action.close') }}
            </b-button>
            <a
              href="https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/IMPORT-DRIVER-LICENSES.xlsx"
              target="_blank"
              class="btn btn-primary ms-2"
              @click="directTo()"
            >
              Template & Data
            </a>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </Layout>
</template>
